import { render, staticRenderFns } from "./ElepantSecretPrescriptionList.vue?vue&type=template&id=fddba8be"
import script from "./ElepantSecretPrescriptionList.vue?vue&type=script&lang=js"
export * from "./ElepantSecretPrescriptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports